const SET_APPLIED_FILTERS = 'setAppliedFilters';

export {
  SET_APPLIED_FILTERS,
};
